import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Checkbox from '../Checkbox';

export const renderCheckbox = ({ input, ...props }) => (
  <Checkbox checked={!!input.value} onChange={input.onChange} {...props} />
);

renderCheckbox.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    onChange: PropTypes.func,
  }),
};

renderCheckbox.defaultProps = {
  input: {
    value: false,
    onChange: () => {},
  },
};

const FormCheckbox = ({ name, ...props }) => <Field name={name} component={renderCheckbox} {...props} />;

FormCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
};

export default FormCheckbox;
